import React from 'react';
import Header from "../../../commons/Header/Header";
import Footer from "../../../commons/Footer/Footer";
import PartnerForm from "../../../commons/PartnerForm/PartnerForm";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// Added new Page
const AgencyFormFr = (props) => {

  return (
    <>
      <Header en='/partner/agency-form' fr='/partenaires/formulaire-agence' lang='fr' />
      <Container className="mainDiv partnerFormPage">
        <Row className="">
          <Col xl={12} className="content">
            <h1>Partenaire avec Travelance</h1>
            <Container>
              <Row className="">
                <Col xl={8} className="">
                  <PartnerForm heading="Remplissez ce formulaire pour commencer le processus d’inscription avec Travelance." lang="fr" typage="/partenaires/formulaire/merci"/>
                </Col>
                <Col lg={4}>
                  <div className="stickyDiv">
                    <div className="holder_block">
                      <h2>Tous les produits</h2>
                      <ul className="list">
                        <li><a href="/produits/l-assurance-voyage/voyage/">Voyage</a></li>
                        <li><a href="/produits/l-assurance-voyage/jeunes/">Jeunesse</a></li>
                        <li><a href="/produits/assurance-visiteurs-au-canada-frair-medicaux-durgence/">Visiteurs au Canada Assurance médicale d’urgence</a></li>
                        <li><a href="/produits/regime-dassurance-accidents-pour-etudiants/">Assurance Accident pour étudiants</a></li>
                      </ul>
                    </div>
                    <div className="holder_block">
                      <h2>Liens rapides</h2>
                      <ul className="list">
                        <li><a href="/au-sujet-de-notre-assureur/">Notre assureur</a></li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Footer lang="fr" />
    </>
  );
}

export default AgencyFormFr;
